function ProjectOverview() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Project.Overview visual. <br/>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 12.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.1.1 - 02.05.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - added function to load the overview after the button back correctly *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.1.0 - 16.06.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - added encodeURI in search to escape some special Characters      *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}
ProjectOverview.prototype = new window.vcTemplate();
ProjectOverview.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it adds the clickhandler,  <br/>
    /// initializes the search <br/>
    /// and fills the list elements with the assignments
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
       
        me.showInfo("", "", false);
       
        me.initTags();
        //me.addFilter();
       
        //me.visual.find("#col5.vc-filter").vcFilter({ callback: function () { me.filter("col5"); } });
        me.visual.find(".vc-list-col-element:not(.col0)").css({ "padding-left": "10px", "box-sizing": "border-box" });
        me.visual.find(".vc-list-item").css({ "padding-right": "0", "box-sizing": "border-box" });
        me.initClickHandler();
        me.visual.find(".vc-filter").vcFilter({ callback: function () { me.filter(); } });
      
        me.visual.find("#lstProjects").height(parseInt(me.height - me.visual.find("#proctOpt").outerHeight() - me.visual.find("#lstHeader").outerHeight())-50);
      
        me.visual.find(".vc-list-table .vc-list-item").filter(":visible").filter(":even").addClass("alt");

      return true;
    } catch (ex) {
        me.writeError('ProjectOverview.init', ex);
        return false;
    }
};
ProjectOverview.prototype.initTags = function () {
    /// <summary>
    /// This function fills the project list with the assignments (user/logger) <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find(".vc-list-table .vc-list-item").each(function (idx, element) {
            var tags = $("<div>");
            var blid = $(element).data("projectid");
            tags.attr("class", "tagList");
            var assignments = $.grep(me.lstLoggerRightsAssignment, function(a) {
                return a.mainid === blid;
            });
            if (assignments.length < 1) {
                tags.append("<div class='tag error'>" + me.resources.noEntriesExist + "</div>");
            } else {
                assignments.forEach(function(ass) {
                    tags.append("<div class='tag' >" + me.lstLogger[ass.assid] + "</div>");
                });
            }
            $(element).find(".col3").html("").append(tags);
        });
           me.visual.find(".vc-list-table .vc-list-item").each(function (idx, element) {
            var tags = $("<div>");
            var blid = $(element).data("projectid");
            var isStaff = "<i class='fa fa-users'></i>";
            tags.attr("class", "tagList");
            var assignments = $.grep(me.lstUserAssignments, function(a) {
                return a.mainid === blid;
            });
            if (assignments.length < 1 || me.lstUsers.length < 1) {
                tags.append("<div class='tag error'>" + me.resources.noEntriesOrOnlyInternal + "</div>");
            } else {

                assignments.forEach(function(ass) {

                    if (me.lstUsers[ass.assid] !== undefined) {
                        tags.append("<div class='tag' data-uid='" +
                            ass.assid +
                            "'title='" +
                            ass.assid +
                            "' data-staff='" +
                            me.lstUsers[ass.assid].isStaff +
                            "' >" +
                            (me.lstUsers[ass.assid].isStaff ? isStaff + " " : "") +
                            me.lstUsers[ass.assid].name +
                            "</div>");
                    } else {
                        tags.append("<div class='tag error'>" + me.resources.uknown +  " UID-" + ass.assid + "</div>");
                    }
                });
            }

            $(element).find(".col4").html("").append(tags);
           });

    } catch (ex) {
        me.writeError('ProjectOverview.initTags', ex);
        return false;
    }
    return true;
};

ProjectOverview.prototype.doEvent = function (event) {
    /// <summary>
    /// This function handles the PROJECT_DET_BACK event<br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        switch(event.msg) {
            case "PROJECT_DET_BACK":
                me.visual.find("#lstHeader").show();
                window.VisualCoreService.getDataByName("WIDGET_PROJECT_OVERVIEW_LIST", me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, JSON.stringify({ 'loadType': 1 }), function (result) {
                    try {
                        var resObj = JSON.parse(result);
                        if (resObj.hasError) {
                            me.showInfo(resObj.retHTML, "", true);

                        } else {
                            me.visual.find("#lstProjects").html(resObj.retHTML);
                            //
                            me.initClickHandler();
                            window.VisualCoreService.getDataByName("WIDGET_PROJECT_OVERVIEW_LIST",me.vcgid,window.getCurrentTimestamp(),0,0,'','',2,JSON.stringify({ 'loadType': 2 }),
                                function (result) {
                                    try {

                                    var retObj = JSON.parse(result);
                                    var retHTML;
                                    if (retObj.hasError) {
                                        me.showInfo(retObj.retHTML, "", true);
                                    } else {
                                        retHTML = JSON.parse(retObj.retHTML);
                                        me.lstLoggerRightsAssignment = retHTML.logger;
                                        me.lstUserAssignments = retHTML.user;
                                        me.initTags();
                                        me.filter();
                                        //me.addFilter();
                                        //me.filter();
                                    }
                                    } catch (ex) {
                                        me.writeError('ProjectOverview.DoEventinnerGetDataDo', ex);

                                    }
                                });
                        }
                    } catch (ex) {
                        me.writeError('ProjectOverview.doEventBtnBack', ex);

                    }
                });

                break;
            default:
                //me.writeError('ProjectOverview.doEvent', "No such Event in ProjectOverview" + " " + event.msg);
                break;
        }
        return true;
    } catch (ex) {
        me.writeError('ProjectOverview.doEvent', ex);
        return false;
    }
};

ProjectOverview.prototype.initClickHandler = function () {
    ///<summary>
    ///Initializes the clickable elements namely the new button (calls the creation view) and the list elements (call the detailview)
    ///</summary>
    var me = this;
    try {
        me.visual.find("#divBtnNewProject").button().off("click").on("click", function () {
            var visual = new window.vcVisual();
            visual.addVisualContentByName("divProject", "WIDGET_PROJECT_CREATION", "Overview", window.getCurrentTimestamp(), me.height, me.width, "", JSON.stringify({ 'loggerid': -1 }), 1);
        });
        me.visual.find('#lstProjects.vc-list-table .vc-list-item').off("click").on("click", function () {
            me.visual.find('#projectFilters').html("");
            var visual = new window.vcVisual();
            visual.addVisualContentByName("lst", "WIDGET_PROJECT_DETAILS", "Projects", window.getCurrentTimestamp(), me.height, me.width, "", JSON.stringify({ 'loggerid': $(this).attr("data-projectid") }), 1);
            me.visual.find("#lstHeader").hide();
        });
        me.visual.find('#lstProjects .vc-list-table .vc-list-item a').off("click").on("click", function (event) {
            event.stopPropagation();
        });
        me.visual.find("#chbStaff").off("change").on("change", function () {
            window.VisualCoreService.getDataByName("WIDGET_PROJECT_OVERVIEW_LIST", me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, JSON.stringify({ 'loadType': 0, 'showStaff': $(this).prop("checked") }), function (result) {
                var retObj = JSON.parse(result);
                if (retObj.hasError) {
                    me.showInfo(retObj.retHTML, "", true);
                } else {
                    me.lstUserAssignments = JSON.parse(retObj.retHTML);
                    me.initTags();
                }

               

            });
        });
        return true;
    } catch (ex) {

        me.writeError('ProjectOverview.initClickHandler', ex);
        return false;
    }
};


ProjectOverview.prototype.filter = function () {
    /// <summary>
    /// This function adds/removes two css-classes ('found' and 'exclude') for filtering loggers.<br/>
    /// When a logger with a filter expression gets found the 'found' class gets added - and the other way round for the 'exclude' class. <br/>
    /// At the end, basically all 'found' classes get shown and all 'exclude' classes get hidden - the favorites state gets considered as well.<br/>
    /// </summary>
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //hide all
        me.visual.find(".vc-list-table .vc-list-item").removeClass("found").data("counterfound", 0).hide();
        //me.visual.find("#col1.vc-filter, #col2.vc-filter, #col3.vc-filter, #col4.vc-filter").trigger("change");

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "found");
        me.visual.find(".vc-list-table .vc-list-item.found").show();
        me.visual.find(".vc-list-table .vc-list-item").removeClass("alt");
        me.visual.find(".vc-list-table .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) {
        me.writeError('ProjectOverview.filter', ex);
        return false;
    }
};
ProjectOverview.prototype.setTagFilter = function (filterObj, listItem, classFound) {
    /// <summary>
    /// This function takes all tags from the vcFilter widget (filterObj) and adds a 'classFound' css class to all entries it founds in 'listItem'.<br/>
    /// It is used as part of the filter function in vc-lists
    /// </summary>
    var me = this;
    var countertext;
    try {
        countertext = "counterfound";
        //we reset the counter for found entries
        me.visual.find(listItem).data(countertext, 0);

        //we filter the optional tags we got from the vc-tags
        var filter = me.visual.find(filterObj).vcFilter("getFilter");

        if (filter !== null) {
            var counter;
            //first, we count how often we find the filter tags in every signal item
            for (var i = 0; i <= filter.length - 1; i++) {
                if (filter[i].length > 0) {
                    me.visual.find(listItem + ":contains('" + filter[i] + "')")
                        .each(function () {
                            counter = parseInt($(this).closest(".vc-list-item").data(countertext), 10);
                            if (isNaN(counter)) {counter = 0; }
                            counter++;
                            $(this).closest(".vc-list-item").data(countertext, counter);
                        });
                }
            }
            //if we found them as often as the number of filter tags - we are the lucky winner and show the entry!!
            //why? if we have several filter tags we have to find all of them in one single signal 
            me.visual.find(listItem)
                .each(function () {
                    if (parseInt($(this).data(countertext), 10) === filter.length) {
                        $(this).addClass(classFound);
                    }
                });
        } else {

            me.visual.find(listItem).addClass(classFound);
        }
    } catch (ex) {
        me.writeError(me.source + '.JS.setTagFilter', ex);
    }
};
